// Email service test utility
let emailjs;

// Dynamic import to handle potential loading issues
async function loadEmailJS() {
  try {
    emailjs = await import('@emailjs/browser');
    console.log('✅ EmailJS loaded successfully:', emailjs);
    return emailjs.default || emailjs;
  } catch (error) {
    console.error('❌ Failed to load EmailJS:', error);
    throw new Error('EmailJS package not available');
  }
}

// Test EmailJS configuration
export async function testEmailConfiguration() {
  console.log('🧪 Testing EmailJS Configuration...');
  
  const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
  
  console.log('📧 Environment Variables:');
  console.log('Service ID:', serviceId);
  console.log('Template ID:', templateId);
  console.log('Public Key:', publicKey ? 'Set' : 'Missing');
  
  // Check if variables are set
  if (!serviceId || serviceId === 'your_service_id') {
    console.error('❌ REACT_APP_EMAILJS_SERVICE_ID not set or using placeholder');
    return false;
  }
  
  if (!templateId || templateId === 'your_template_id') {
    console.error('❌ REACT_APP_EMAILJS_TEMPLATE_ID not set or using placeholder');
    return false;
  }
  
  if (!publicKey || publicKey === 'your_public_key') {
    console.error('❌ REACT_APP_EMAILJS_PUBLIC_KEY not set or using placeholder');
    return false;
  }
  
  console.log('✅ All EmailJS environment variables are configured');
  return true;
}

// Send test email
export async function sendTestEmail(testEmail = 'test@example.com') {
  try {
    console.log('🧪 Sending test email...');
    
    // Load EmailJS first
    const emailjsLib = await loadEmailJS();
    
    // Initialize EmailJS
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    emailjsLib.init(publicKey);
    
    const testParams = {
      to_email: testEmail,
      to_name: 'Test User',
      from_name: 'Skyline Backpackers',
      from_email: 'booking@skylinebackpackers.in',
      booking_id: 'TEST123',
      guest_name: 'Test User',
      guest_email: testEmail,
      guest_phone: '9999999999',
      check_in: 'Aug 25, 2025',
      check_out: 'Aug 27, 2025',
      nights: '2',
      beds: '1',
      total_amount: '1258',
      payment_method: 'Online Payment (Razorpay)',
      selected_beds: 'A1 (Window, Room 1)',
      special_requests: 'None',
      location: 'Sindhi Colony, Hyderabad',
      contact_phone: '+91 90327 97797',
      contact_email: 'booking@skylinebackpackers.in'
    };
    
    console.log('📧 Test email parameters:', testParams);
    
    const response = await emailjsLib.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      testParams
    );
    
    console.log('✅ Test email sent successfully:', response);
    return {
      success: true,
      response: response,
      message: 'Test email sent successfully'
    };
    
  } catch (error) {
    console.error('❌ Test email failed:', error);
    console.error('❌ Error details:', {
      message: error.message,
      stack: error.stack,
      name: error.name
    });
    
    return {
      success: false,
      error: error.message,
      details: error
    };
  }
}

// Debug EmailJS status
export async function debugEmailJS() {
  console.log('🔍 EmailJS Debug Information:');
  
  try {
    const emailjsLib = await loadEmailJS();
    console.log('EmailJS loaded:', typeof emailjsLib !== 'undefined');
    console.log('EmailJS methods:', Object.keys(emailjsLib || {}));
    
    // Check if EmailJS is properly initialized
    try {
      console.log('EmailJS version:', emailjsLib.version || 'Unknown');
    } catch (e) {
      console.log('EmailJS version check failed:', e.message);
    }
  } catch (error) {
    console.log('EmailJS loading failed:', error.message);
  }
  
  // Environment check
  console.log('Environment variables:');
  console.log('NODE_ENV:', process.env.NODE_ENV);
  console.log('All REACT_APP vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP')));
}
